<template>
  <v-dialog v-model="show" persistent width="600">
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <v-card :loading="isLoading" :disabled="isLoading">
      <v-card-title> Delete {{ invoice.code }} ?</v-card-title>
      <v-card-text> You will not be able to recover it </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn depressed outlined @click="show = false">Cancel</v-btn>
        <v-btn depressed color="error" @click="clickDelete">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'InvoiceDeleteDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ isLoading: 'invoice/isDeleteLoading' }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    ...mapActions({ delete: 'invoice/delete' }),
    async clickDelete() {
      await this.delete(this.invoice.id)
      this.show = false
      this.$emit('delete')
    },
  },
}
</script>
